import React, { useEffect, useRef, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import InvoiceMain from "../../../components/Invoices/InvoiceMain";
import { FaCog, FaEye } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useReactToPrint } from "react-to-print";

function WebOrder() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "Refrence No",
      accessorKey: "sale_no",
    },
    {
      header: "Order Type",
      accessorKey: "order_type",
      cell: (row) => row.getValue()?.name,
    },
    {
      header: "Order From",
      accessorKey: "order_from",
      cell: (row) => (row.getValue() === "app" ? "App" : "Web"),
    },
    {
      header: "Date(Time)",
      accessorKey: "sale_date",
    },
    {
      header: "Customer",
      accessorKey: "customer",
      cell: (row) => row.getValue()?.name || row.row.original.guest.name,
    },
    {
      header: "Order By",
      accessorKey: "accepted_from",
      cell: (row) => row.getValue(),
    },
    {
      header: "Total Payable",
      accessorKey: "total_payable",
    },
    {
      header: "Payment Method",
      accessorKey: "payment",
      cell: (row) => row.getValue()?.name,
    },

    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      cell: (row) => (
        <ActionDropdown
          setInvoiceData={setInvoiceData}
          invoice={row.row.original}
          handlePrint={handlePrint}
        />
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [invoiceData, setInvoiceData] = useState();
  const [setting, setSetting] = useState();

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Invoice",
  });

  useEffect(() => {
    const fetchOrders = () => {
      axios
        .get(`${apiKey}/api/rms/customer/fetch_all_order_light`, {
          params: {
            orderFrom: "web",
            outletId: user?.user.outlet_id,
          },
        })
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          setError(err.response.data.message);
        })
        .finally(() => {
          setPageLoading(false);
        });
    };
    handleCSRF(fetchOrders);

    axios
      .get(`${apiKey}/api/rms/admin/settings`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setSetting(res.data);
      })
      .catch((err) => {
        setError(err.response.data.message);
      });
  }, [user?.token, user?.user.outlet_id]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Web Orders"}
        error={error}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
      {invoiceData && (
        <div className="hidden">
          <div ref={componentRef}>
            <InvoiceMain setting={setting} invoiceDetails={invoiceData} />
          </div>
        </div>
      )}
    </main>
  );
}

function ActionDropdown({ setInvoiceData, invoice, handlePrint }) {
  const [showDropdown, setShowDropDown] = useState(false);

  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-d-bg-text" />
          <IoIosArrowDown className="text-d-bg-text" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <button
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
            onClick={() => {
              setInvoiceData(invoice);
              setTimeout(() => {
                handlePrint();
              }, 100);
            }}
          >
            <FaEye />
            <p> View Invoice </p>
          </button>
        </div>
      </div>
    </>
  );
}

export default WebOrder;
